/* eslint-disable */
export default {
  _Title: 'Title',
}